const currentYear = new Date().getFullYear();
const contacts = {
  name: "Dusha",
  slogan: "Seaside Dining, Elevated.",
  tel: "+306945846117",
  email: "dusha.halkidiki@gmail.com",
  schedule: "Mon-Sat: 11AM - 23PM",
  address: "Leoforos Nikis, 38,  Nea Kallikratia, Halchidiki",
  coords: {
    restSpot: { latitude: 40.31014129002744, longitude: 23.064639118995103 },
    beachSpot1: { latitude: 40.30973099821641, longitude: 23.064613317581866 },
  },
  //keys of radiuses and coords should be the same
  radiuses: { restSpot: 10, beachSpot1: 15 },
  datesBeachSpot: {
    start: new Date(currentYear, 3 - 1, 1),
    end: new Date(currentYear, 10 - 1, 30),
  },
  chat_id: "-4074718635",
  backendEndpoints: { waiter: "/button2607", bill: "/button2607" },
  useGeo: false,
};

export default contacts;
